module.exports = __webpack_public_path__ + "static/assets/6b8350e1c4fcb14dddb1c4bac60690fc.png";